"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = fetchEntityIfNeeded;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _fetchEntity = _interopRequireDefault(require("./fetchEntity"));

var _entityKey = _interopRequireDefault(require("./entityKey"));

var _marked =
/*#__PURE__*/
_regenerator["default"].mark(fetchEntityIfNeeded);

function fetchEntityIfNeeded(entity) {
  var args,
      fetchOptions,
      key,
      loaded,
      _args = arguments;
  return _regenerator["default"].wrap(function fetchEntityIfNeeded$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          args = _args.length > 1 && _args[1] !== undefined ? _args[1] : [];
          fetchOptions = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
          key = (0, _entityKey["default"])(fetchOptions.key, entity, args);
          _context.next = 5;
          return (0, _effects.select)(entity.loaded, key);

        case 5:
          loaded = _context.sent;

          if (!loaded) {
            _context.next = 10;
            break;
          }

          _context.next = 9;
          return (0, _effects.select)(entity.data, key);

        case 9:
          return _context.abrupt("return", _context.sent);

        case 10:
          _context.next = 12;
          return (0, _effects.call)(_fetchEntity["default"], entity, args, fetchOptions);

        case 12:
          return _context.abrupt("return", _context.sent);

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}